import { Component } from '@theme/component';

/**
 * Paul Kenzie footer'ı (PK-05).
 * 768 px altında kolon başlıkları akordeon gibi çalışır; üstünde tüm kolonlar açıktır
 * ve başlık butonları sekme sırasından çıkarılır.
 *
 * @extends {Component}
 */
class PkFooter extends Component {
  /** @type {MediaQueryList} */
  #mobile = window.matchMedia('(max-width: 767px)');

  connectedCallback() {
    super.connectedCallback();
    this.#sync();
    this.#mobile.addEventListener('change', this.#sync);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#mobile.removeEventListener('change', this.#sync);
  }

  /**
   * Bir kolonu açar ya da kapatır (yalnızca mobilde).
   * @param {MouseEvent} event
   */
  toggle(event) {
    if (!this.#mobile.matches) return;
    const button = /** @type {HTMLElement} */ (event.target);
    const column = button.closest('.pk-footer__col');
    if (!(column instanceof HTMLElement)) return;

    const open = !column.hasAttribute('data-open');
    column.toggleAttribute('data-open', open);
    button.setAttribute('aria-expanded', String(open));
  }

  /** Başlık butonlarının durumunu kırılım noktasına göre eşitler. */
  #sync = () => {
    const isMobile = this.#mobile.matches;
    for (const button of this.querySelectorAll('.pk-footer__toggle')) {
      if (!(button instanceof HTMLElement)) continue;
      const column = button.closest('.pk-footer__col');
      const open = !isMobile || Boolean(column?.hasAttribute('data-open'));
      button.setAttribute('aria-expanded', String(open));
      button.tabIndex = isMobile ? 0 : -1;
    }
  };
}

if (!customElements.get('pk-footer')) {
  customElements.define('pk-footer', PkFooter);
}
